import { Component } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Subject, filter, takeUntil } from 'rxjs';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  EventMessage,
  EventType,
  InteractionStatus,
} from "@azure/msal-browser";
import { USER_INFO } from 'src/shared/data-store';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = "Imperial PVP";
  router;
  showLoader;
  isIframe = false;
  login_display = false;
  private readonly _destroying$ = new Subject<void>();
  saved_access_token_db = "";
  constructor(
    private broadcastService: MsalBroadcastService,
    private authService: MsalService,
    private userService: UserService,
    private _router: Router,
    private dataService: DataService,
    private http: HttpClient,
  ) {
    this.router = _router.url;
    console.log(this.router);
    this.dataService.showLoader.subscribe((val) => {
      this.showLoader = val;
    });
  }

  hasRoute(route: string) {
    return this.router?.url?.includes(route);
  }

  getAccessTokenAndCallGraphAPI() {
    this.authService
      .acquireTokenSilent({ scopes: ["GroupMember.Read.All"] })
      .subscribe((res) => {
        // debugger;
        console.log(res);
      });
    // this.authService.acquireTokenSilent({
    //   scopes: ['group.Read.All']
    // }).then(result=>{
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type':  'application/json',
    //     Authorization: 'Bearer '+result.accessToken
    //   })}

    // this.http.get("https://graph.microsoft.com/v1.0/groups?$select=id,displayName",httpOptions).toPromise().then(result=>{console.log(result)});
    // })
  }
  ngOnInit() {
    console.log(environment.environmentName);
    console.log(
      "this log is for checking qa deployment: current environment" +
        `${environment.environmentName}`,
    );
    this.isIframe = window !== window.parent && !window.opener;
    this.broadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => {
          return msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS;
        }),
      )
      .subscribe({
        next: (result: EventMessage) => {
          if (result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
            this.saveToken(result.payload);
          }
        },
        error: (error) => {
          // if(result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS){
          console.log("error :: ", error);
          console.log("error in broadcastService");

          // }
        },
      });
    this.broadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None,
        ),
        takeUntil(this._destroying$),
      )
      .subscribe(() => {
        this.login_display =
          this.authService.instance.getAllAccounts().length > 0;
      });

    this.getAccessTokenAndCallGraphAPI();
  }

  saveToken(payload: any) {
    if (this.saved_access_token_db !== payload.accessToken) {
      let user_info = {
        username: payload.account.username,
        access_token: payload.accessToken,
        expiresOn: payload.expiresOn,
        name: payload.account.name,
      };
      localStorage.setItem(USER_INFO, JSON.stringify(user_info));
      // this.userService.saveUserToken(user_info).subscribe({
      //   next: (res: any) => {
      //     this.saved_access_token_db = res.data['result'].access_token;
      //   },
      //   error: (error) => {
      //     console.log('error :: ', error);
      //   },
      // });
    }
  }

  login() {
    this.authService.loginRedirect();
  }
  logout() {
    this.authService.logoutRedirect();
  }
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
